<script setup lang="ts">

import Product from "~/components/shop/Product.vue";
import Section from "~/components/layout/Section.vue";
import Container from "~/components/layout/Container.vue";
import Tags from "~/components/shop/Tags.vue";

const config = useRuntimeConfig()
const response = await GqlGetPostMetalTShirts();
const products = response.products;

const offersResponse = await GqlGetOffers();
const offers = offersResponse.offers;

const route = useRoute()

useHead({
    title: "Neuronoir | Post Metal T-Shirts",
    meta: [
        {name: 'description', content: 'Browse through our post metal T-Shirts from bands and solo projects based in Romania.'},
        { name: 'keywords', content: 'band shirts, romanian band shirts, romanian band t-shirts, post metal merchandise, post rock, post metal, post metal t-shirts, romanian post metal, t-shirts, record label, romanian record label' },
        { property: 'og:title', content: 'Neuronoir | Post Metal T-Shirts' },
        { property: 'og:description', content: 'Browse through our post metal T-Shirts from bands and solo projects based in Romania.' },
        { property: 'og:url', content: 'https://neuronoir.art' + route.path },
        { property: 'canonical', content: 'https://neuronoir.art' + route.path },
    ],
})
</script>

<template>
    <Container class="bg-neurodarkgreyvar">
        <nuxt-link to="/shop" class="text-neurolink mt-3 block">Back to shop</nuxt-link>

        <Section
            title="Post Metal T-Shirts"
            description="Browse through our post metal T-Shirts from bands and solo projects based in Romania."
        >
            <Tags></Tags>
        </Section>

        <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3 pb-20">
            <div class="col-span-1" v-for="product, i in products" :key="i" v-if="offers">
                <Product
                    :offers="offers"
                    :title="product.title"
                    :type="product.type"
                    :image-url="product.image.url"
                    :brand="product.brand"
                    :label="product.label"
                    :slug="product.slug"
                    :subtype="product.subtype"
                    :productId="product.productId"
                ></Product>
            </div>
        </div>
    </Container>
</template>
